<aw-dialog
  (onClose)="dialogRef.close($event)"
  [content]="content"
  [width]="width"
  [data]="data"
  [title]="data.headline"
  [footer]="footer">
  <ng-template #content>
    <div class="flex flex-col">
      <aw-text-input
        class="bg-standard-background"
        [id]="'name'"
        label="Kategoriename"
        [formControl]="form.controls.name">
        {{ cmsTextProvider.ticketCategories.errorTicketCategory }}
      </aw-text-input>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="flex w-full flex-row justify-end gap-2">
      <aw-button
        [id]="'discard-changes'"
        [style]="'primary-alt'"
        [type]="'button'"
        [text]="cmsTextProvider.shared.cancel"
        (click)="dialogRef.close()">
      </aw-button>
      <aw-button
        [id]="'add-new-category'"
        [style]="'primary'"
        [type]="'button'"
        [text]="cmsTextProvider.shared.confirm"
        [isDisabled]="!form.valid"
        (click)="addNewCategory(form.controls.name.value)">
      </aw-button>
    </div>
  </ng-template>
</aw-dialog>
